module.exports = __webpack_public_path__ + "img/bermuda.d1c8883d.svg";